/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';

import { FancyActionTrackerFactory } from 'src/app/common/fancy-firebase/services/fancy-action-tracker-factory.service';
import { RoleListFactory, RoleList } from 'src/app/common/fancy-firebase/services/factories';
import { FancyIdJoin } from 'src/app/common/fancy-firebase/base/FancyIdJoin';
import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyFirebaseList } from 'src/app/common/fancy-firebase/base/FancyFirebaseList';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { DefaultLoggerService } from '@touchplan/logging';
import firebase from 'firebase/compat/app';

@Component({
	selector: 'harness2',
	templateUrl: './harness2.component.html',
	styleUrls: ['./harness2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [LoggerServiceFactory.provide('Harness2Component')],
})
export class Harness2Component implements OnInit {
	public projectId = 'broken-need-real-project';

	public colors: FancyFirebaseList<any, FancyAction>;
	public roles: RoleList;

	constructor(
		private roleListFactory: RoleListFactory,
		private angularFireDatabase: AngularFireDatabase,
		private fancyActionTrackerFactory: FancyActionTrackerFactory,
		private logger: DefaultLoggerService
	) {}

	public ngOnInit() {
		// boilerplate required to "new" FancyFirebaseList directly, hidden behind the scenes if using a factory
		// used to inject services into FancyFirebaseLists, these are the minimally required ones
		const angularLand = {
			angularFireDatabase: this.angularFireDatabase,
			fancyActionTrackerFactory: this.fancyActionTrackerFactory,
		};

		const projectsPath = fancyFirebaseGetters.getProjectsPath(this.projectId);
		// barebones usage
		const roleColorList = new FancyFirebaseList(
			angularLand, //service injection
			// Previously projectId was used for sample project V3
			fancyFirebaseReferencer
				.getLegacyRef<firebase.database.Reference>(projectsPath, this.projectId)
				.child('colors/roles'),
			FancyAction //base class for list items
		);
		// joiner, connnects two lists together
		const roleColorJoiner = new FancyIdJoin('roleColor', roleColorList);
		// factory created list
		// Previously projectId was used for sample project V3
		const roleListPath = fancyFirebaseGetters.getRolesPath(this.projectId);
		const roleList = this.roleListFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(roleListPath, this.projectId),
			roleColorJoiner
		);

		this.colors = roleColorList;
		this.roles = roleList;

		this.colors.rawEvent$.subscribe((c) => this.logger.log('color update', c));
		// this.colors.list$.subscribe(c => this.logger.log('color list update', c));
		this.roles.rawEvent$.subscribe((c) => this.logger.log('role update', c));

		this.logger.log('lists', this.colors, this.roles);
	}

	//half-assed srcList write
	public changeColor1() {
		const action = new FancyAction(
			{
				$id: '-KwCRCchbfenUZTkTFSm',
				color: 'lime',
				id: '-KwCRCchbfenUZTkTFSm',
			},
			'notUsed'
		);
		this.colors.appEvent$.next(action);
	}
	//half-assed srcList write
	public deleteColor2() {
		const action = { key: '-KwCRCchbfenUZTkTFSo', type: 'notUsed', payload: null };
		this.colors.appEvent$.next(action);
	}
	//half-assed baseList write
	public changeRole1() {
		const action = new FancyAction(
			{
				$id: '-Jw2SsIUqL_Jg1xfTvwg',
				roleColor: '-KwCRCchbfenUZTkTFSr',
				roleId: '-Jw2SsIUqL_Jg1xfTvwg',
				roleName: 'cheese',
			},
			'notUsed'
		);
		this.roles.appEvent$.next(action);
	}
	//half-assed baseList write
	public addRole() {
		const action = new FancyAction(
			{
				$id: '-new',
				prevData: {},
				roleColor: '-KwCRCchbfenUZTkTFSm',
				roleId: '-Jw2SsIUqL_Jg1xfTvwg',
				roleName: 'cheese',
			},
			'notUsed'
		);
		this.roles.appEvent$.next(action);
	}
}
